// views/informs/GeneralInformView.js
import React, { useEffect, useState } from 'react';
import './GeneralInformView.css';
import '../InformView.css';
import axios from 'axios';
import { Spin } from 'antd';
import { useParams, useLocation } from 'react-router-dom';

import { apiUrl } from '../../../utility/Connections';
import LeadershipGeneral from '../../../components/informs/leadershipGeneral/leadershipGeneral';
import CultureGeneral from '../../../components/informs/cultureGeneral/cultureGeneral';

const GeneralInformView = () => {
    const { evl_id } = useParams();
    const location = useLocation();
    const [showLoading, setShowLoading] = useState(true);

    const [selectedEvaluation, setSelectedEvaluation] = useState(null);

    const [totalResults, setTotalResults] = useState({});
    const [individualResults, setIndividualResults] = useState([]);

    const [orgLogo, setOrgLogo] = useState(null);

    useEffect(() => {
        getEvaluation(evl_id);
    }, [evl_id]);

    const getEvaluation = (evl_id) => {
        setShowLoading(true);

        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        };

        axios.get(`${apiUrl}/evaluations/get-evaluation-info-by-id/${evl_id}/`, headers)
            .then(function (response) {
                const data = response.data;
                setSelectedEvaluation(data);
                getEvaluationResults(data.evl_id, data.evl_org_id);
            })
            .catch(function (error) {
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    };

    const getEvaluationResults = async (evl_id, org_id) => {
        setShowLoading(true);

        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        };

        axios.get(`${apiUrl}/informs/get-evaluation-results/${evl_id}/`, headers)
            .then(function (response) {
                const data = response.data;
                setTotalResults(data.totals);
                setIndividualResults(data.results);
                getOrganizationLogo(org_id);
            })
            .catch(function (error) {
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    };

    const getOrganizationLogo = (orgId) => {
        axios.get(`${apiUrl}/organizations/get-organization-logo/${orgId}/`)
            .then(function (response) {
                const data = response.data.org_logo;
                setOrgLogo(data);
                setShowLoading(false);
            })
            .catch(function (error) {
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    }

    if (showLoading) {
        return (
            <div className="display-center-row display-center-column align-full-center" style={{ height: '100vh' }}>
                <Spin size="large" tip="Cargando informe..." />
            </div>
        );
    }

    if (!totalResults) {
        return <div>Error al cargar la información del informe.</div>;
    }

    const params = new URLSearchParams(location.search);
    const forcedType = params.get('type');
    const evalType = selectedEvaluation?.evl_srv_id;
    const isCultureEval = evalType === 3 || (typeof evalType === 'string' && evalType.toLowerCase().includes('cultur'));
    const isCulture = forcedType === 'culture' || isCultureEval;
    return (
        <div className="informe-wrapper">
            {isCulture ? (
                <CultureGeneral totalResults={totalResults} selectedEvaluation={selectedEvaluation} orgLogo={orgLogo} />
            ) : (
                <LeadershipGeneral totalResults={totalResults} individualResults={individualResults} selectedEvaluation={selectedEvaluation} orgLogo={orgLogo} />
            )}
        </div>
    );
};

export default GeneralInformView;
